import keycloakApi from './keycloak-auth';

export interface ApiVersionResponse {
  version: string;
}

export const getApiVersion = async (): Promise<ApiVersionResponse> => {
  return keycloakApi.authenticatedApiCall<ApiVersionResponse>('/internal/version', {
    method: 'GET',
  });
};
